export default __webpack_public_path__ + "static/media/client-17.ae7b4aea.webp";